import { getOrganizations, ORGANIZATIONS_STATE_KEY } from '@/apis/organizations-apis';
import { useQuery } from '@tanstack/react-query';

export const useOrganizationSearchQuery = (debouncedSearchQuery: string) => {
  const trimmed = debouncedSearchQuery.trim();

  const { data, isLoading } = useQuery({
    queryKey: [ORGANIZATIONS_STATE_KEY, trimmed],
    queryFn: async () => {
      if (!trimmed) return { items: [] };
      const res = await getOrganizations({
        search_query: trimmed,
      });
      return res.data || {};
    },
    enabled: trimmed.length > 0,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    organizations: data?.items ?? [],
    isLoading,
  };
};
